
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import store from '@/store';
import * as OM from '@/Model';
import * as VM from '@/viewModel';

@Options({
    components: {}
})
export default class ProviderGarmentProductionsTable extends Vue {

    @Prop({
        default: () => []
    }) garmentProductions: OM.EditGarmentProductionsVM[];

    @Prop({
        default: false
    }) showCTAs: boolean;

    created() {}

    get isReadOnly() {
        return store.state.loggedUser.role == VM.Roles.ReadOnly;
    }

    editGarmentManagement(index: number) {
        this.$emit('editGarmentManagement', index);
    }
    deleteGarmentManagement(index: number) {
        this.$emit('deleteGarmentManagement', index);
    }

}
